import React, { useEffect } from "react";
import "./FormModal.css";

/**
 * Модалка с произвольной формой (в отличие от `ConfirmModal`, где только текст и две кнопки).
 * Закрывается по Esc и клику по фону. Содержимое и кнопки передаёт вызывающий.
 */
export default function FormModal({ open, title, onClose, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fm-overlay" onMouseDown={onClose}>
      <div className="fm-modal" role="dialog" aria-modal="true" onMouseDown={(e) => e.stopPropagation()}>
        {title && <div className="fm-title">{title}</div>}
        {children}
      </div>
    </div>
  );
}
